// External Imports
import { Fragment, useContext, useState } from "react";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";

// Internal Imports
import { isoDateToString } from "../../util/format-date";
import ListLabels from "../UI/ListLabels";
import Heading from "../UI/Heading";
import { UtilityContext } from "../../context/util-context";
import NoRecordsFound from "../UI/NoRecordsFound";

/** ========================================================================
 * * CustomerBookings Component
 * This component renders a list of bookings by a customer.
 * ========================================================================== */

export default function CustomerBookings({ bookings = [] }) {
  // Load Context
  const { navigate } = useContext(UtilityContext);

  // Initialize States
  const [show, setShow] = useState(false);

  // Sort bookings by date
  bookings = bookings.sort(
    (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
  );

  return (
    <div className="grid gap-2">
      <Heading
        title="Bookings"
        text="List of all bookings made for this customer."
        onClick={() => setShow(!show)}
        isBackArrow={false}
      >
        {show ? (
          <TbChevronUp className="icon" onClick={() => setShow(false)} />
        ) : (
          <TbChevronDown className="icon" onClick={() => setShow(true)} />
        )}
      </Heading>

      {show && (
        <Fragment>
          {bookings.length > 0 ? (
            <div className="list max-h-[400px]">
              <div className="labels lg:grid-cols-6">
                <ListLabels
                  labels={[
                    "Date Created",
                    "Start Date",
                    "End Date",
                    { name: "Vehicle", classes: "lg:col-span-2" },
                    "Total Fees",
                  ]}
                />
              </div>
              {bookings.map((booking) => (
                <div
                  key={booking.id}
                  className="grid text-sm pill lg:grid-cols-6 text-stone-200"
                  onClick={(e) =>
                    navigate(`/bookings/info?id=${booking.id}`, e)
                  }
                >
                  <p className="text-stone-400">
                    {isoDateToString(booking.dateCreated)}
                  </p>
                  <p className="font-semibold">
                    {isoDateToString(booking.startDate) || "-"}
                  </p>
                  <p className="font-semibold">
                    {isoDateToString(booking.endDate) || "-"}
                  </p>
                  <p className="text-stone-400 lg:col-span-2">
                    {booking.vehicle.year} {booking.vehicle.model}{" "}
                    {booking.vehicle.vin.substring(13, 17)}
                  </p>
                  <p className="font-semibold">
                    ${booking.totalFees?.toFixed(2)}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <NoRecordsFound />
          )}
        </Fragment>
      )}
    </div>
  );
}
